import $ from "jquery";

if (document.querySelector(".BlogsliderTop_slider")) {
  const blogSliders = document.querySelectorAll(".BlogsliderTop_slider");
  blogSliders.forEach(slider => {
    $(slider).slick({
      slidesToShow: 1,
      autoplay: true,
      autoplaySpeed: 3500,
      appendArrows: $(slider.closest(".BlogsliderTop").querySelector(".slider-controls__arrows")),
      dots: true,
      appendDots: $(slider.closest(".BlogsliderTop").querySelector(".slider-controls__dots")),
      slidesToScroll: 1,
      prevArrow: "<button type='button' class='slick-prev d-none d-md-block'><i class='fal fa-chevron-left'></i></button>",
      nextArrow: "<button type='button' class='slick-next'><i class='fal fa-chevron-right'></i></button>",
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    });
  });
}

try {
  if(document.querySelector("#cardBody")) {

    var w = $(window).width();
    if(w <= 991){
      $(window).on("scroll", function(e) {
        let element = $('#cardBody');
        if(element.offset().top - 500 < $(document).scrollTop() ) {
          element.addClass("bodyBlog__blogTextCard");
        }else {
          element.removeClass("bodyBlog__blogTextCard");
        }
      });
    }
  }
} catch (e) {
  console.log(`Exception in cardBody => ${e}`);
}